<template>
    <div class="container">

        <div class="card">
            <section class="hero is-primary">
                <div class="hero-body">
                    <div class="container">
                        <h1 class="title">
                            Documents
                        </h1>
                    </div>
                </div>
            </section>
        </div>

        <div class="card">
            <div class=" card-header">
                <div class="card-header-title">
                    Documents
                </div>
            </div>
            <div class="card-content">
                This functionality is coming soon... until this is ready, manage your documents in each property you are working on.
                <!-- <Billing /> -->
            </div>
        </div>

    </div>
</template>

<script>
export default {
  props: {
    open: false
  }
};
</script>

<style>
</style>
